import {Router} from "@angular/router";
import {DatePipe} from "@angular/common";
import {Component, inject, OnInit} from '@angular/core';

import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

import {appRoutes} from "@numizmat/constants";
import {environment} from "@numizmat/environments";
import {ImageComponent} from "@numizmat/components";
import {UserAdLikeApiService} from "@numizmat/services/core";
import {UserAdLikeResponse} from "@numizmat/services-models/core";

@Component({
  selector: 'nz-ad-likes-modal',
  standalone: true,
  imports: [
    DatePipe,
    ImageComponent
  ],
  templateUrl: './ad-likes-modal.component.html',
  styleUrl: './ad-likes-modal.component.scss'
})
export class AdLikesModalComponent implements OnInit {
  private router: Router = inject(Router);
  private activeModal: NgbActiveModal = inject(NgbActiveModal);
  private userAdLikeApiService: UserAdLikeApiService = inject(UserAdLikeApiService);

  protected adId!: string;
  protected adTitle!: string;
  protected loading: boolean = true;
  protected likes: UserAdLikeResponse[] = [];

  protected readonly appRoutes = appRoutes;

  public ngOnInit(): void {
    this.getAllLikes();
  }

  protected closeModal(route?: string[]): void {
    this.activeModal.dismiss();

    if (!!route) {
      setTimeout(() => {
        this.router.navigate(route).then();
      }, 100);
    }
  }

  private getAllLikes(): void {
    this.userAdLikeApiService.getAllLikes(this.adId).subscribe({
      next: response => {
        this.loading = false;
        this.likes = response.map(x => {
          return {
            userId: x.userId,
            username: x.username,
            dateTime: x.dateTime,
            userProfileImageId: x.userProfileImageId,
            userProfileImageUrl: !!x.userProfileImageId
              ? `${environment.apiImageUserProfileUrl}/${x.userId}/${x.userProfileImageId}`
              : environment.apiImageDefaultUserProfileUrl
          }
        });
      }
    });
  }
}
